import { useQuery } from "react-query";

import { IPlacePostType } from "~/entity/CombinationRules/model/schema";

import { useCombinationRules } from "./useCombinationRules";
import { COMBINATION_RULES_QUERY_KEY } from "./useGetCombinationRules";

export const useGetPlacePostTypes = () => {
  const { placePostTypesGet } = useCombinationRules();

  const { data, isLoading, isError } = useQuery({
    queryKey: [COMBINATION_RULES_QUERY_KEY, "placePostTypes"],
    queryFn: () => placePostTypesGet(),
  });

  // Реальный ответ — { data: [...] }; оставлены фолбэки на массив и { items }.
  const payload = data?.data as
    | IPlacePostType[]
    | { data?: IPlacePostType[]; items?: IPlacePostType[] }
    | undefined;
  const postTypes: IPlacePostType[] | undefined = Array.isArray(payload)
    ? payload
    : (payload?.data ?? payload?.items);

  return {
    postTypes,
    isLoading,
    isError,
  };
};
